<!--ATTENTION!-->
<!--TAILWIND CLASSES ARE WRITTEN INLINE FOR EXAMPLE PURPOSES ONLY-->
<!--REAL COMPONENTS SHOULD CONTAIN THESE CLASSES INSIDE STYLE FILES ONLY!-->
<!--DO NOT USE TAILWIND CLASSES IN HTML TEMPLATES!-->

<div class="page-wrapper">
  <div class="text-title-1">text-title-1</div>
  <div class="text-title-2">text-title-2</div>
  <div class="text-title-3">text-title-3</div>
  <div class="text-bold">text-bold</div>
  <div class="text-default">text-default</div>
  <div class="text-small-bold">text-small-bold</div>
  <div class="text-small-thin">text-small-thin</div>
  <div class="text-small-uppercase">text-small-uppercase</div>

  <br>
  <br>

  <div class="w-full">
    <div class="page-header-container">
      <a class="text-title-2 back-ref">Inventory</a>
      <a class="text-title-2 back-ref">Inventory Drugs</a>
      <div class="text-title-2 header">Lisdexamefetamine Dimesylate 20 mg CHEW TAB</div>
    </div>
  </div>

  <br>

  <div class="w-1/2">
    <app-button styleClass="settings"
                subStyle="blue"
                text="Open Dialog With Progress"
                class="cancel"
                (clicked)="openDialogProgress()"
    >
    </app-button>
    <br>
    <br>
    <app-button styleClass="settings"
                subStyle="red"
                text="Open Drug Record Widget"
                class="cancel"
                (clicked)="openWidget()"
    >
    </app-button>
    <br>
    <app-dialog-progress [show]="showDialogProgress"
                         [labels]="dialogProgressLabels"
                         [progress]="currentDialogProgress"
                         (cancel)="showDialogProgress = false"
    >
      <h3 class="p-10">CONTENT HERE: AuthProgressEnum step {{currentStep}}</h3>
    </app-dialog-progress>
    <app-alert
      class="m-1"
      [hasCustomCloseButton]="true"
      (closeAlert)="closeThisAlert('48344')"
      [message]="'Message example Confirm'"
      [type]="AlertTypesEnum.Confirm"
    ></app-alert>
    <app-alert
      class="m-1"
      (closeAlert)="closeThisAlert('893859')"
      [message]="'Message example Info'"
      [type]="AlertTypesEnum.Info"
    ></app-alert>
    <app-alert
      class="m-1"
      (closeAlert)="closeThisAlert('47348')"
      [message]="'Message example Success'"
      [type]="AlertTypesEnum.Success"
    ></app-alert>
    <app-alert
      class="m-1"
      (closeAlert)="closeThisAlert('483948')"
      [message]="'Message example Error'"
      [type]="AlertTypesEnum.Error"
    ></app-alert>
  </div>

  <div class="buttons m-2">
    <app-button text="Primary"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button text="Primary"
                [disabled]="true"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button icon="icon-mail-white"
                text="Primary icon"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button subStyle="secondary"
                icon="icon-mail-light-blue"
                text="Secondary icon"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button subStyle="secondary"
                disabled
                text="Secondary icon"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button subStyle="white"
                icon="icon-mail-gray"
                text="White icon"
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button subStyle="white"
                icon="icon-mail-gray"
                text="White icon"
                disabled
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <app-button styleClass="settings"
                subStyle="blue"
                icon="icon-mail-gray"
                text="Button settings blue"
                disabled
                (clicked)="clickPrimary()"
    ></app-button>
    <br>
    <br>
    <app-button styleClass="settings"
                subStyle="red"
                text="Button settings red"
                class="cancel"
                (clicked)="clickPrimary()"
    >
    </app-button>
  </div>

  <div class="alerts">
    <ng-template #customNotification let-notificationData="notification">
      <app-alert
              [hasCustomCloseButton]="notificationData.hasCloseButton"
        (closeAlert)="closeThisAlert(notificationData.id)"
        [message]="notificationData.message"
        [type]="notificationData.type"
      ></app-alert>
    </ng-template>
  </div>

  <form novalidate [formGroup]="exampleForm" class="form w-1/2">

    <div class="inputs-container">
      <app-search-input (searchCleared)="handleSearchInput('')"
                        [searchResults]="drugList$ | async"
                        (searchValueChanged)="handleSearchInput($event)"
                        (optionSelected)="optionSelected($event)"
                        [loading]="loading$ | async"
                        [placeholder]="'Scan barcode or search drug name, NDC'"
                        formControlName="searchOptionName"
      ></app-search-input>
    </div>

    <div class="inputs-container">
      <div class="half-width">
        <app-input [type]="'text'"
                   [label]="'Server URL'"
                   [prefix]="'https://'"
                   placeholder="www.example.com"
                   formControlName="urlLink"
        ></app-input>
      </div>
      <div class="half-width">
        <app-input [type]="'text'"
                   [label]="'Server URL (disabled)'"
                   placeholder="www.example.com"
                   formControlName="networkLink"
                   [disable]="true"
        ></app-input>
      </div>
    </div>

    <div class="inputs-container">
      <div class="half-width">
        <app-input [type]="'password'"
                   [label]="'Password'"
                   [hidePassword]="isPasswordHidden"
                   placeholder="Your Password"
                   formControlName="password"
        ></app-input>
      </div>
      <div class="w-1/2">
        <app-input [type]="'number'"
                   [label]="'Wholesaler Account Number'"
                   placeholder="Acc Number"
                   formControlName="accountNumber"
        ></app-input>
      </div>
    </div>

    <div class="inputs-container">
      <div class="w-1/2">
        <app-options-list
          formControlName="radioInputValue"
          (optionSelected)="chosenOption($event)"
          [optionsList]="optionsList"
        ></app-options-list>
      </div>
      <div class="w-1/2">
        <app-dropdown
          formControlName="period"
          [placeholder]="'Select Period'"
          [options]="statesList"
        ></app-dropdown>
      </div>
    </div>
    <div class="inputs-container">
      <div class="w-1/2">
        <app-checkbox label="All Drugs" [checked]="showOpenDialog"></app-checkbox>
        <app-checkbox formControlName="checkCodeine">
          <span class="cursor-pointer text-sm text-gray-900 font-medium">Codeine Sulfate 60 mg TAB</span>
          <span class="cursor-pointer text-sm text-gray-500 font-medium"> (0054-0245-25)</span>
        </app-checkbox>

        <app-checkbox class="mb-2"
                      *ngFor="let item of drugsList"
                      (change)="drugOptionsChanged(item.id)"
                      [id]="item.id"
        >
          <span class="cursor-pointer text-sm text-gray-900 font-medium">{{item.name}}</span>
        </app-checkbox>
      </div>
      <div class="w-1/2 flex flex-wrap">
        <app-badge class="m-1">Badge</app-badge>
        <app-badge class="m-1">Badge with long text is truncated</app-badge>
        <app-badge class="m-1" [isOption]="true" (removeOption)="removeBadge()">
          Option
        </app-badge>
        <app-badge class="m-1"
                   [color]="BadgeColorsEnum.Gray"
                   [isOption]="true"
                   (removeOption)="removeBadge()"
        >
          Option gray
        </app-badge>
        <app-badge class="m-1"
                   [color]="BadgeColorsEnum.Red"
                   [isOption]="true"
                   (removeOption)="removeBadge()"
        >
          Option red
        </app-badge>
        <app-badge class="m-1"
                   [color]="BadgeColorsEnum.Green"
                   [isOption]="true"
                   (removeOption)="removeBadge()"
        >
          Option green
        </app-badge>
        <app-badge class="m-1"
                   [color]="BadgeColorsEnum.Yellow"
                   [isOption]="true"
                   (removeOption)="removeBadge()"
        >
          Option yellow
        </app-badge>
        <app-badge class="m-1"
                   [color]="BadgeColorsEnum.Blue"
                   [isOption]="true"
                   (removeOption)="removeBadge()"
        >
          Option blue and long
        </app-badge>
      </div>
    </div>

    <div class="inputs-container">
      <app-multiselect-dropdown
        [placeholder]="'Select Drugs'"
        [data]="drugList$ | async"
        [loading]="loading$ | async"
        formControlName="multiselectDrugs"
        (filterChanged)="filterDrugsOnSearch($event)"
        [settings]="dropdownSettings"
        (dropDownClosed)="dropDownClose()"
        (selected)="itemSelect($event)"
        (deSelected)="itemDeSelect($event)"
        (selectedAll)="selectAll($event)"
      ></app-multiselect-dropdown>
    </div>

    <div class="inputs-container">
      <div class="w-1/2">
        <app-switcher (change)="openDialog($event)" formControlName="switchTheme"></app-switcher>
      </div>
      <div class="w-1/2 relative">
        <button
          type="button"
          appMenu
          [hasAnimation]="true"
          [placement]="'bottom-right'"
          [autoClose]="'outside'"
          [menuContent]="userMenuContent"
          triggers="manual"
          #userMenu="appMenu"
          (click)="toggleUserMenu(userMenu, 'anastasia@mainstreet.gmail.com')"
        >
          Toggle menu
        </button>

        <ng-template #userMenuContent let-userEmail="user">
          <div class="menu-container primary">
            <div class="menu-header">
              <div class="label">
                Signed in as
              </div>
              <div class="menu-data">
                {{userEmail}}
              </div>
            </div>
            <div class="menu-item">
              <div class="option">
                My Profile
              </div>
            </div>
            <div appMenu
                 [placement]="'left-top'"
                 [autoClose]="'outside'"
                 [menuContent]="changePharmacyContent"
                 triggers="manual"
                 #changePharmacyMenu="appMenu"
                 (click)="toggleUserMenu(changePharmacyMenu)"
                 class="menu-item submenu"
            >
              <div class="option">
                Change Pharmacies
              </div>
            </div>
            <div class="menu-item">
              <div class="option">
                Logout
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #changePharmacyContent>
          <div class="submenu-container primary">
            <div class="sub-menu-item">
              Market Street Pharmacy
            </div>
            <div class="sub-menu-item">
              Pearl Street Pharmacy
            </div>
            <div class="sub-menu-item">
              Wall Street Pharmacy
            </div>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="inputs-container">
      <app-pin-input class="mr-4"
                     [focused]="true"
                     (pinValueComplete)="pinCompleted($event)"
      ></app-pin-input>
      <app-pin-input [isLarge]="true"
                     (pinValueComplete)="pinCompleted($event)"
      ></app-pin-input>
    </div>

    <div class="inputs-container">
      <table class="table-primary">
        <thead>
        <tr>
          <th class="text-left sort" scope="col">
            First Key
            <img [class.asc]="tableOptions.asc" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="desc"/>
          </th>
          <th class="text-left" scope="col">Left Aligned</th>
          <th class="text-center" scope="col">Center</th>
          <th class="text-right" scope="col">Right Aligned</th>
          <th class="text-right" scope="col">Last Column</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of tableOptions.rows">
          <th scope="row">
            <div class="heading">
              {{row.firstKey}}
            </div>
            <div class="secondary">
              0555-0767-02
            </div>
          </th>
          <td>{{row.leftAligned}}</td>
          <td class="text-center">{{row.center}}</td>
          <td class="text-right">{{row.rightAligned}}</td>
          <td class="text-right">{{row.lastColumn}}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th scope="row" colspan="5">{{'8'}} Records</th>
        </tr>
        </tfoot>
      </table>
    </div>

    <div class="inputs-container">
      <div class="w-1/2 mr-1">
        <app-input [type]="'text'"
                   [label]="'Simple DatePicker'"
                   placeholder="Datepicker"
                   formControlName="datepicker"
                   [owlDateTimeTrigger]="dt1"
        ></app-input>
        <input (dateTimeChange)="updateDatePicker($event)"
               class="w-0 h-0" [owlDateTime]="dt1" type="text" />
        <owl-date-time [panelClass]="'primary'" [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="w-1/2 ml-1">
        <app-input [type]="'text'"
                   [label]="'Range DatePicker'"
                   placeholder="Range Datepicker"
                   formControlName="datepickerRange"
                   [owlDateTimeTrigger]="dt2"
        ></app-input>
        <input class="w-0 h-0"
               (dateTimeChange)="updateDatePickerRange($event)"
               [min]="minDate"
               [rangeSeparator]="' - '"
               [max]="maxDate"
               [owlDateTime]="dt2"
               [selectMode]="'range'"
               type="text"
        />
        <owl-date-time [panelClass]="'primary'" [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
    </div>
  </form>

  <app-dialog (cancel)="closeDialog()"
              (save)="closeDialog()"
              [header]="'Invite Teammates'"
              [subHeader]="'Invite new users to join your team.'"
              [cancelBtnText]="'Cancel btn'"
              [saveBtnText]="'Save content'"
              [show]="exampleForm.get('switchTheme').value"
  >
    Content here
  </app-dialog>

</div>
